// Configuração de cores da marca para templates de e-mail
export const brandColors = {
  primary: '#3b65f5',      // Cor primária
  secondary: '#ff4a8f',    // Cor secundária
  header: '#1F1746',       // Cor do header
  background: '#F5F7FA',   // Cor de fundo
  text: '#333333',         // Cor do texto principal
  secondaryText: '#666666', // Cor do texto secundário
  white: '#ffffff',        // Branco
  border: '#E1E4E8',       // Cor das bordas
  success: '#4CAF50',      // Verde para sucesso
  warning: '#FFD600',      // Amarelo para avisos
};

// Logo da empresa
export const companyLogo = 'https://cdn.brandfetch.io/idNdb_MPJ2/w/4501/h/4501/theme/light/logo.png?c=1dxbfHSJFAPEGdCLU4o5B';

// Configurações da empresa
export const companyConfig = {
  name: 'Trivium',
  domain: 'trivium.com.br',
  supportEmail: 'atendimento@trivium.com.br',
  phone: '(11) 3181-5940',
  address: 'Av. das Nações Unidas, 14261 - 6º Andar - Brooklin Paulista, São Paulo - SP',
  social: {
    linkedin: 'https://www.linkedin.com/company/trivium',
    instagram: 'https://www.instagram.com/trivium',
    facebook: 'https://www.facebook.com/trivium',
    twitter: 'https://twitter.com/trivium',
  },
};
